import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  Heading,
  IconButton,
  SimpleGrid,
  Skeleton,
  Text,
  VStack,
} from '@chakra-ui/react';
import React from 'react';
import { BsArrowLeft } from 'react-icons/bs';
import { useHistory } from 'react-router-dom';
import { Page } from '../../../../shared/models/page';
import DisplayCard from './DisplayCard';

interface Props {
  elements: any[];
  page: Page;
  loading?: boolean;
}

const Sidebar: React.FC<Props> = ({ elements, loading, page }) => {
  const history = useHistory();
  return (
    <Box
      bg="#F9F9F9"
      w="20rem"
      h="100%"
      overflow="auto"
      p={4}
      boxShadow="xl"
      css={{
        '&::-webkit-scrollbar': {
          width: '6px',
        },
        '&::-webkit-scrollbar-track': {
          width: '6px',
        },
        '&::-webkit-scrollbar-thumb': {
          background: 'var(--chakra-colors-gray-500)',
          borderRadius: '24px',
        },
      }}
    >
      {loading ? (
        <VStack spacing={4}>
          <Skeleton h="25px" w="100%" borderRadius="4px" />
          <Skeleton h="25px" w="100%" borderRadius="4px" />
          <Skeleton h="25px" w="100%" borderRadius="4px" />
          <Skeleton h="25px" w="100%" borderRadius="4px" />
          <Skeleton h="25px" w="100%" borderRadius="4px" />
        </VStack>
      ) : (
        <SimpleGrid>
          <Flex alignItems="center" mb="4" gridGap={2}>
            <IconButton
              aria-label="add-banner"
              bg="transparent"
              onClick={() => {
                history.push('/dynamic_pages');
              }}
              icon={<BsArrowLeft size={16} />}
            />
            <Text as="h1" fontSize="lg" fontWeight="bold">
              {page?.name}
            </Text>
          </Flex>
          <Accordion allowToggle w="100%" bg="#FFFFFF">
            {elements.map(
              (element: any) =>
                element.active && (
                  <AccordionItem key={element.id}>
                    <AccordionButton>
                      <Heading
                        as="h2"
                        fontWeight="medium"
                        flex={1}
                        textAlign="left"
                        fontSize="lg"
                      >
                        {element.name}
                      </Heading>
                      <AccordionIcon />
                    </AccordionButton>
                    <AccordionPanel>
                      <Flex flexWrap="wrap">
                        {element?.displays?.map(
                          (display: any) =>
                            display.active && (
                              <DisplayCard display={display} key={display.id} />
                            ),
                        )}
                      </Flex>
                    </AccordionPanel>
                  </AccordionItem>
                ),
            )}
          </Accordion>
        </SimpleGrid>
      )}
    </Box>
  );
};

export default Sidebar;
